import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/explore.scss';

function KnowledgeFlow({ steps, title = 'What to figure out next' }) {
	if (!steps || steps.length === 0) return null;
	return (
		<section className="knowledge-flow">
			<h2 className="knowledge-flow__title">{title}</h2>
			<p className="knowledge-flow__intro">Every answer leads to the next question — follow the thread without hunting through menus.</p>
			<div className="knowledge-flow__steps">
				{steps.map((step, i) => (
					<React.Fragment key={step.to + step.label}>
						<Link to={step.to} className="knowledge-flow__step">
							<span className="knowledge-flow__step-num">{i + 1}</span>
							<span className="knowledge-flow__step-body">
								<strong>{step.label}</strong>
								{step.desc && <span>{step.desc}</span>}
							</span>
							<span className="knowledge-flow__arrow" aria-hidden="true">→</span>
						</Link>
						{i < steps.length - 1 && <div className="knowledge-flow__connector" aria-hidden="true" />}
					</React.Fragment>
				))}
			</div>
		</section>
	);
}

export default KnowledgeFlow;
